
import React from 'react'
import { mdx } from '@mdx-js/react'

/* @jsxRuntime classic */
/* @jsx mdx */
import { assertIsFn, AddContext } from "@storybook/addon-docs";

import { Canvas, Meta, Story } from '@storybook/addon-docs';
import template from './list.twig';
const defaultItems = [
  'Design Tokens',
  'Objects',
  'Components',
  'Scope',
  'Utilities',
  'Themes',
];
const tagNames = ['ul', 'ol'];


const layoutProps = {
  
};
const MDXLayout = "wrapper"
function MDXContent({
  components,
  ...props
}) {
  return <MDXLayout {...layoutProps} {...props} components={components} mdxType="MDXLayout">

    <Meta title="Objects/List" parameters={{
      docs: {
        inlineStories: false
      }
    }} args={{
      items: defaultItems,
      tag_name: tagNames[0]
    }} argTypes={{
      class: {
        type: {
          name: 'string'
        }
      },
      items: {
        type: {
          name: 'array'
        }
      },
      tag_name: {
        options: tagNames,
        type: {
          name: 'enum'
        },
        control: {
          type: 'inline-radio'
        }
      }
    }} mdxType="Meta" />
    <h1>{`List`}</h1>
    <p>{`The `}<inlineCode parentName="p">{`o-list`}</inlineCode>{` object presents list items in a straightforward and unopinionated manner. While it can be applied to any container, it was designed specifically for `}<inlineCode parentName="p">{`<ul>`}</inlineCode>{` and `}<inlineCode parentName="p">{`<ol>`}</inlineCode>{` elements.`}</p>
    <p><strong parentName="p">{`Important:`}</strong>{` Remember to include the `}<inlineCode parentName="p">{`role="list"`}</inlineCode>{` attribute on `}<inlineCode parentName="p">{`<ul>`}</inlineCode>{` elements using this pattern to avoid `}<a parentName="p" {...{
        "href": "https://www.scottohara.me/blog/2019/01/12/lists-and-safari.html"
      }}>{`an issue with unstyled lists and Safari/VoiceOver`}</a>{`.`}</p>
    <p>{`By default, `}<inlineCode parentName="p">{`o-list`}</inlineCode>{` removes default spacing and list item decorators:`}</p>
    <Canvas mdxType="Canvas">
  <Story name="Default" height="200px" mdxType="Story">
    {args => template(args)}
  </Story>
    </Canvas>
    <h2>{`Inline List`}</h2>
    <p>{`The `}<inlineCode parentName="p">{`o-list--inline`}</inlineCode>{` modifier arranges items in a horizontal row, wrapping to new lines as needed. This is a good fit for lists of tags or related links:`}</p>
    <Canvas mdxType="Canvas">
  <Story name="Inline" args={{
        class: 'o-list--inline'
      }} mdxType="Story">
    {args => template(args)}
  </Story>
    </Canvas>
    <h2>{`Columns`}</h2>
    <p>{`Lists can be displayed in multiple columns using a modifier class. Use the format `}<inlineCode parentName="p">{`o-list--X-column@Y`}</inlineCode>{`, where `}<inlineCode parentName="p">{`X`}</inlineCode>{` is the desired column count (from 2 to 3) and `}<inlineCode parentName="p">{`Y`}</inlineCode>{` is the desired `}<a parentName="p" {...{
        "href": "/docs/design-tokens-breakpoint--page"
      }}>{`breakpoint`}</a>{` (from `}<inlineCode parentName="p">{`s`}</inlineCode>{` to `}<inlineCode parentName="p">{`xl`}</inlineCode>{`).`}</p>
    <Canvas mdxType="Canvas">
  <Story name="Column" args={{
        class: 'o-list--3-column@l'
      }} mdxType="Story">
    {args => template(args)}
  </Story>
    </Canvas>
    </MDXLayout>;
}
;
MDXContent.isMDXComponent = true;

export const defaultStory = (args => template(args));
defaultStory.storyName = 'Default';
defaultStory.parameters = { storySource: { source: 'args => template(args)' } };

export const inline = (args => template(args));
inline.storyName = 'Inline';
inline.args = {
  class: 'o-list--inline'
};
inline.parameters = { storySource: { source: 'args => template(args)' } };

export const column = (args => template(args));
column.storyName = 'Column';
column.args = {
  class: 'o-list--3-column@l'
};
column.parameters = { storySource: { source: 'args => template(args)' } };

const componentMeta = { title: 'Objects/List', parameters: {
  docs: {
    inlineStories: false
  }
}, args: {
  items: defaultItems,
  tag_name: tagNames[0]
}, argTypes: {
  class: {
    type: {
      name: 'string'
    }
  },
  items: {
    type: {
      name: 'array'
    }
  },
  tag_name: {
    options: tagNames,
    type: {
      name: 'enum'
    },
    control: {
      type: 'inline-radio'
    }
  }
}, includeStories: ["defaultStory","inline","column"],  };

const mdxStoryNameToKey = {"Default":"defaultStory","Inline":"inline","Column":"column"};

componentMeta.parameters = componentMeta.parameters || {};
componentMeta.parameters.docs = {
  ...(componentMeta.parameters.docs || {}),
  page: () => <AddContext mdxStoryNameToKey={mdxStoryNameToKey} mdxComponentAnnotations={componentMeta}><MDXContent /></AddContext>,
};

export default componentMeta;